import styled from '@emotion/styled';

import { useRisingStarCopy } from './copy';

/** 샛별 안내 문구 (정책 B-1 원문). MG 안내처럼 접지 않고 상시 노출 */
export default function BonusNotice() {
  const COPY = useRisingStarCopy();
  return (
    <SNotice>
      <strong>{COPY.noticeTitle}</strong>
      <ul>
        {COPY.notice.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
    </SNotice>
  );
}

const SNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.bg.secondary};
  color: ${({ theme }) => theme.color.label.secondary};
  ${({ theme }) => theme.font.caption1_m};

  @media ${({ theme }) => theme.device.large} {
    padding: 12px;
  }
`;
